// const API_URL = "http://192.168.2.22/";

import {utils, write} from "xlsx";
import { saveAs } from 'file-saver'
//const API_URL = "http://192.168.2.24:8005";
//const API_URL = "https://acil-api.consultandfly.com"
const API_URL = "https://api.acilcocukdoktoru.com"
//const API_URL = "http://localhost:8000"

const LIST_OPTIONS = {
    customHeadRender: () => null,
    filter: false,
    selectableRows: "none",
    filterType: "dropdown",
    responsive: "standard",
    rowsPerPage: 1020,
    fixedHeader: false,
    //fixedSelectColumn: true,
    tableBodyHeight: "100%",
    print: false,
    download: true,
    searchOpen: false,
    draggableColumns: {
        enabled: false,
        transitionTime: 400,
    },
    rowStyle: {
        fontSize: 9,
        lineHeight: 0.1,
    },
    downloadOptions: {
        filterOptions: {
            useDisplayedColumnsOnly: true,
            useDisplayedRowsOnly: true,
        },
    },
    viewColumns: true,
    search: true,
    pagination: true,

    textLabels :{
        selectedRows: {
            text: "satır seçildi",
            delete: "SiparişeEkle",
            deleteAria: "Seçilenleri siparişe aktar",
        },
        pagination: {
            next: "İleri",
            previous: "Geri",
            rowsPerPage: "Sayfadaki satır sayısı:",
            displayRows: "/",
        },
        toolbar: {
            search: "Ara",
            downloadCsv: "XLSX İndir",
            print: "Çıktı Al",
            viewColumns: "Sütunları Göster",
            filterTable: "Tabloyu Süz",
        },
        filter: {
            all: "Tümünü Göster",
            title: "Filtreler",
            reset: "Sıfırla",
        },
        viewColumns: {
            title: "Sütunları Göster",
            titleAria: "Sütunları Göster/Gizle",
        },

    },
    onDownload: (buildHead, buildBody, columns, values) => {
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";

        console.log(values.forEach(val => console.log(val)));

        const json = values.reduce((result, val) => {
            const temp = {};
            val.data.forEach((v, idx) => {
                temp[columns[idx].name] = v;
            });
            result.push(temp);
            return result;
        }, []);

        const fileName = `Liste`;
        const ws = utils.json_to_sheet(json);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
        // cancel default  CSV download from table
        return false;
    },
    expandableRowsOnClick: true,
    expandableRows: false,
    //rowsExpanded: datas.map((el, i) => {return i}),
};


export {API_URL,LIST_OPTIONS };
